jQuery(document).ready(function() {
    console.log("ready modaljs");
    jQuery(".close-modal-btn").click(function() {
        console.log("close modal");
        jQuery(".inventory-modal-container").hide();
    });
    setTimeout(function() {
        jQuery(".request-button").click(function() {
            console.log("Open Modal Form");
            var vehicleCard = jQuery(this).closest(".vehicle-card");
            var customerId = vehicleCard.data("customerid");
            var buildModel = vehicleCard.data("model");
            var buildPrice = vehicleCard.data("price");
            var vehicleFeatures = vehicleCard.find(".vehicle-features").text();
            var vehicleDescription = "Model: " + buildModel + "\nPrice: " + buildPrice + "\nFeatures:\n" + vehicleFeatures;
            var customerField = jQuery(".request-a-quote-inventory > form .customer-id > input").first();
            var vehicleDescriptionField = jQuery(".request-a-quote-inventory > form .vehicle-description > input").first();
            customerField.val(customerId);
            vehicleDescriptionField.val(vehicleDescription);
            jQuery(".inventory-modal-container").show();
            jQuery("html,body").animate({
                scrollTop: jQuery("#mainmodal").offset().top
            });
        });
    }, 1000);
});
